export const PAGE_ANNOUNCEMENTS = 'pg_announcements';
export const PAGE_LOGIN = 'pg_login';
export const PAGE_ORDERS = 'pg_orders';
export const PAGE_HOME = 'pg_home';
export const PAGE_REPORTS = 'pg_reports';
export const PAGE_PAYMENTS = 'pg_payments';
export const PAGE_ADMIN_ADDRESSES = 'pg_admin_addresses';
export const PAGE_PRODUCTS_OF_INTEREST = 'pg_productsOfInterest';
